import React from "react";

const LazyMeetingDocuments = React.lazy(() =>
  import("./MeetingDocuments").then((module) => ({ default: module.MeetingDocuments }))
);

export default LazyMeetingDocuments;
